/**
 * Concept Archetype
 * 
 * @Version 1.0
 * @Author Daniel Lepe
 */
 
import _ from 'lodash'

const baseController = 'lunchpresencias'

const baseIndex = baseController + '/index'

const archetype = [
     // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id',
        type: 'hidden'
    },
    [
        {
            label: 'Propietario',
            key: 'usuario_id_pk',
            type: 'select',
            readonly: true
        },
    ],
    null,
    [
        {
            label: 'Cede',
            key: 'lunch_cedes_id',
            type: 'select',
            readonly: true
        },
    ],
    [
        {
            label: 'Grupo',
            key: 'lunch_grupo_id',
            type: 'select',
            readonly: true
        },
    ],
    [
        {
            label: 'Tipo',
            key: 'tipo',
            type: 'hidden',
            options: [
                {value: 'directo', text: 'Directo'},
                {value: 'alumno', text: 'Alumno'},
                {value: 'cooperativa', text: 'Cooperativa'},
            ],
            readonly: true
        },
    ],
    null,
    [
        {
            label: 'Nombre / lonchera',
            key: 'nombre'
        },
    ],
    [
        {
            label: 'NOTAS ALIMENTARIAS',
            key: 'notas_alimentarias',
            type: 'textarea'
        },
    ]
];

const captions = [
    // {key: 'usuarioImagen', label: ''},
    {key: 'directaNombre', label: 'Lonchera'},
    {key: 'cede_titulo'},
    {key: 'usuarioNombre', label: 'Propietario'},
    {key: 'monedero'},
    {key: 'grupo', label: 'Grupo'},
    {key: 'tipo'},
    {key: 'estatus'},
    {key: '_'},
]

const captionsForSelectedGroup = (() => {
    let allowed = [
        'directaNombre',
        'usuarioNombre',
        'monedero',
        // 'tipo',
        '_',
    ];
    return _.filter(captions, item => {
        return (allowed.indexOf(item.key) !== -1)
    })
})()

const captionsForSelectedGroupEmpresa = (() => {
    let allowed = [
        'usuarioNombre',
        'monedero',
        // 'tipo',
        '_',
    ];
    return _.filter(captions, item => {
        return (allowed.indexOf(item.key) !== -1)
    })
})()

const captionsForUserEmpresa = _.filter(captions, field => {
    let skpMtrx = [
        '_', // TO FIX
        'usuarioNombre',
        'monedero',
        'directaNombre',
        'tipo',
    ]
    if(skpMtrx.indexOf(field.key) === -1)
        return true;
})

const captionsForUserEscuela = _.filter(captions, field => {
    let skpMtrx = [
        'usuarioNombre',
        'monedero',
        'tipo',
        '_', // TO FIX
    ]
    if(skpMtrx.indexOf(field.key) === -1)
        return true;
})

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId) );
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

let buildAPIFromTipo = (tipo, cedesId, gruposId) => {
    let str = baseController + '/';
    if(!_.isNil(cedesId)){
        str += 'indexbycede/' + tipo + '/' + cedesId ;
    } else if (!_.isNil(gruposId)) {
        str += 'indexbygrupo/'  + tipo + '/' + gruposId;
    } else {
        str += 'index'
    }
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

export {
    archetype,
    captions, captionsForUserEmpresa, captionsForUserEscuela, captionsForSelectedGroup, captionsForSelectedGroupEmpresa,
    baseIndex,
    automodalHandler,
    buildAPIFromTipo
}